import React, {useState} from 'react';
import {node, bool, string} from 'prop-types';
import classNames from 'classnames';
import {default as Icon} from '@sinclair-digital/sbg-storyline-components/src/components/Icon';
import {chevronUp} from 'react-icons-kit/feather/chevronUp';
import {chevronDown} from 'react-icons-kit/feather/chevronDown';
import styles from './Expando.css';

interface ExpandoProps {
    children: React.ReactNode;
    open?: boolean;
    label?: string;
}

const Expando: React.FunctionComponent<ExpandoProps> = ({open, label, children}) => {
    const [isOpen, setOpen] = useState(open);
    return (
        <aside className={styles.Expando}>
            <header>
                <button className={styles.button} onClick={() => setOpen(!isOpen)}>
                    {label}
                    {isOpen ? <Icon icon={chevronUp} /> : <Icon icon={chevronDown} />}
                </button>
            </header>
            <div className={classNames({[styles.open]: isOpen, [styles.content]: true})}>{children}</div>
        </aside>
    );
};
Expando.propTypes = {
    children: node.isRequired,
    open: bool,
    label: string,
};
Expando.defaultProps = {
    open: false,
    label: 'Expand',
};

export default Expando;
